import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import './assets/css/main.css';
import 'react-toastify/dist/ReactToastify.css';
import { ApolloProvider } from '@apollo/react-hooks';
import { PrivateRoute, PrivateStudentRoute } from './app/elements';
import './app/register-fa-icons';
import * as pages from './app/pages';
import client from './app/apollo_client';
import InviteProcessPage from './app/v2/invite/pages/InviteProcessPage';
import DocumentsDetailPage from './app/enrollment/pages/DocumentsDetailPage';
import HealthDetailPage from './app/health/pages/HealthDetailPage';
import ImportsPage from './app/pages/imports/ImportsPage';
import axios from 'axios';

class Main extends React.Component {
  constructor(props) {
    super(props);

    // Configure authorization request header.
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = `JWT ${token}`;
    } else {
      delete axios.defaults.headers.common.Authorization;
    }
  }

  render() {
    const { token } = this;
    return (
      <ApolloProvider client={client}>
        <Switch>
          <PrivateRoute
            path="/dashboard-v2"
            component={pages.VersionRedirectToV2Page}
          />
          <PrivateRoute
            path="/edicts"
            component={pages.VersionRedirectToV2Page}
          />
          <PrivateRoute path="/aguarde" component={pages.WaitingProject} />
          <PrivateRoute
            navbar
            exact
            path="/financers"
            component={pages.Financers}
          />
          <PrivateRoute
            navbar
            exact
            path="/contracts"
            component={pages.PendingContractsPage}
          />
          <PrivateRoute
            navbar
            path="/financers/:token"
            component={pages.FinancerSummary}
          />
          <PrivateRoute
            navbar
            exact
            path="/academic"
            component={pages.DocumentsPage}
          />
          <PrivateRoute
            navbar
            path="/academic/:token"
            component={DocumentsDetailPage}
          />
          <PrivateRoute
            navbar
            exact
            path="/health"
            component={pages.HealthPage}
          />
          <PrivateRoute
            navbar
            path="/health/:token"
            component={HealthDetailPage}
          />
          <PrivateRoute
            navbar
            path="/enrollments"
            component={pages.Enrollments}
          />
          <PrivateRoute
            navbar
            path="/onboarding"
            component={pages.Onboarding}
          />
          <PrivateRoute navbar path="/support" component={pages.Support} />
          <PrivateRoute navbar path="/importacao" component={ImportsPage} />
          <PrivateRoute navbar path="/documents" component={pages.TransferirDocumentos} permission="core.view_imporacao_menu" />
          <PrivateRoute
            navbar
            path="/dashboard"
            component={pages.DashboardPage}
          />
          <PrivateRoute navbar exact path="/naap" component={pages.NAAPPage} />
          <PrivateRoute
            navbar
            path="/naap/:token"
            component={pages.NAAPDetailsPage}
          />
          <PrivateRoute
            navbar
            path="/invite"
            component={InviteProcessPage}
            permission="invites.view_menu_convocacao"
          />
          <PrivateStudentRoute
            path="/processos"
            component={pages.OnboardingProcesses}
          />
          <PrivateRoute
            navbar
            exact
            path="/reports/sql"
            component={pages.SQLReportListPage}
          />
          <PrivateRoute
            navbar
            exact
            path="/reports/sql/new"
            component={pages.SQLReportFormPage}
          />
          <PrivateRoute
            navbar
            exact
            path="/reports/sql/:id"
            component={pages.SQLReportDetailPage}
          />
          <PrivateRoute
            navbar
            exact
            path="/reports/sql/view/:id"
            component={pages.SQLReportViewPage}
          />
          <PrivateRoute
            navbar
            path="/templates"
            component={pages.ListTemplatesPage}
          />
          <PrivateRoute
            navbar
            path="/template/new"
            component={pages.TemplatePage}
          />
          <PrivateRoute
            navbar
            path="/template/:id"
            component={pages.TemplatePage}
          />
          <PrivateRoute
            navbar
            exact
            path="/reports/sql"
            component={pages.SQLReportListPage}
          />
          <PrivateRoute
            navbar
            exact
            path="/reports/sql/new"
            component={pages.SQLReportFormPage}
          />
          <PrivateRoute
            navbar
            exact
            path="/reports/sql/:id"
            component={pages.SQLReportDetailPage}
          />
          <PrivateRoute
            navbar
            exact
            path="/reports/sql/view/:id"
            component={pages.SQLReportViewPage}
          />
          <PrivateRoute
            navbar
            path="/templates"
            component={pages.ListTemplatesPage}
          />
          <Redirect to={token ? '/dashboard' : '/login'} />
        </Switch>
      </ApolloProvider>
    );
  }
}

export default Main;
